<script>
import VClamp from 'vue-clamp';
import { mapState } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';
import { newMembers, followNewUser } from '../api/new-members';

export default {
  name: 'CpExploreNewMembers',
  components: {
    CpButton: require('../button').default,
    handleImageError: require('../mixins/utils').default,
    CpDialogAuthForm: require('../auth-form/dialog-auth-form').default,
    VClamp,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginLeft: require('../directives/margins').marginLeft,
  },
  props: {
    title: { type: String, default: 'People to Follow' },
  },
  mounted() {
    this.getMembers();
  },
  data() {
    return {
      members: [],
      showAuthModal: false,
      clickedNewUserId: null,
      indexClickedNewUser: undefined,
      isLoginCallbackActive: false,
    };
  },
  computed: {
    ...mapState(useUserStore, ['isUserLogin']),
  },
  methods: {
    getMembers() {
      newMembers()
        .then(response => {
          this.members = response.new_members;
        })
        .catch(error => {
          console.warn(error);
        });
    },
    followNewUser(user_id, index) {
      this.clickedNewUserId = user_id;
      this.indexClickedNewUser = index;

      if (!this.isUserLogin) {
        this.showAuthModal = true;
      } else {
        this.handleFollowNewUser();
      }
    },
    handleCloseButton() {
      this.showAuthModal = false;
      const isSocialLogin = window.sessionStorage.getItem('openWindowForSocialLogin');
      if (!this.isLoginCallbackActive && !isSocialLogin) {
        this.indexClickedNewUser = undefined;
        this.clickedNewUserId = null;
      }
    },
    async loginCallbackAction() {
      this.isLoginCallbackActive = true;
      await this.handleFollowNewUser();
      this.isLoginCallbackActive = false;
    },
    handleFollowNewUser() {
      followNewUser(this.clickedNewUserId).then(response => {
        this.indexClickedNewUser = undefined;
        this.clickedNewUserId = null;
        newMembers()
          .then(response => {
            this.members = response.new_members;
          })
          .catch(error => {
            console.warn(error);
          });
      });
    },
  },
};
</script>
<template>
  <div v-if="members && members.length">
    <h3 class="H3 black-color" v-margin-top="0">{{ title }}</h3>
    <div v-for="(member, index) in members" :key="member.id">
      <div class="memberItemContainer">
        <a class="memberImage" :href="member.permalink">
          <div class="circle-container">
            <img :src="`${member.profile_image}`" alt="New's image" @error="handleImageError" />
          </div>
        </a>
        <span class="step-text header-label" style="margin-bottom: 5px">
          <a :href="member.permalink" style="color: black; word-break: break-word">
            <VClamp autoresize :max-lines="2">{{ member.fullname }}</VClamp>
          </a>
          <CpButton
            @click="followNewUser(member.id, index)"
            :loading="indexClickedNewUser === index"
            thin
            style="margin-top: 5px; border-color: var(--primary4); color: var(--primary4); border: 1px solid !important; padding: 0 !important"
            >Follow</CpButton
          >
        </span>
      </div>
    </div>
    <CpDialogAuthForm v-if="showAuthModal" :handleCloseButton="handleCloseButton" showSignUp :callback-action="loginCallbackAction" />
  </div>
</template>

<style scoped>
.memberItemContainer {
  display: flex;
  align-items: center;
  padding: 4px 8px;
}

.memberImage {
  background: var(--primary1);
  margin-right: 10px;
  border-radius: 50%;
}

.circle-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
